export default "__VITE_ASSET__BXxXN1Yh__"